export function updateCf7AcceptanceTimeOnPolicyChange() {
    const formatDateTime = (date) => {
        const pad = (value) => String(value).padStart(2, '0');
        return (
            pad(date.getDate()) +
            '.' +
            pad(date.getMonth() + 1) +
            '.' +
            date.getFullYear() +
            ' ' +
            pad(date.getHours()) +
            ':' +
            pad(date.getMinutes()) +
            ':' +
            pad(date.getSeconds())
        );
    };

    document.addEventListener('change', function (e) {
        const target = jQuery(e.target);
        if (target.attr('name') !== 'policy' || target.attr('type') !== 'checkbox') {
            return;
        }

        const acceptance_details_input = target.closest('form').find('input[name="form-acceptance_details"]');

        if (!acceptance_details_input.length) {
            return;
        }

        const ip = window?.user_ip ?? '';
        const date = formatDateTime(new Date());
        const text = `IP: ${ip}. Время: ${date}`;

        acceptance_details_input.val(text);
    });
}
